// ADDED
import React, { useState } from "react";
import { CreateTableNew as CreateTable, SearchBar, GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import EditIcon from '@mui/icons-material/Edit';
import { useMedicalClearanceAccess } from "../../hooks/useMedicalClearanceAccess";
import MedicalClearanceAccessModal from "../../components/modules/MedicalClearanceAccess/components/MedicalClearanceAccessModal";

const MedicalClearanceAccessPage = ({ isHideSideMenu }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const { 
    loading, 
    data, 
    showMessage, 
    message, 
    isSuccess, 
    handleSearch, 
    updateAccess 
  } = useMedicalClearanceAccess();

  const headers = ["ID", "Access Type", "Is Manager", "Is Processor", "Actions"];
  const accessors = ["id", "description", "isMedicalClearanceManager", "isMedicalClearanceProcessor", "actions"];

  const handleEdit = (row) => {
    setSelectedTemplate(row);
    setIsModalOpen(true);
  };

  const handleSaveAccess = async (roleType) => {
    const success = await updateAccess(selectedTemplate.id, roleType);
    if (success) setIsModalOpen(false);
  };

  const actions = [
    {
      name: "Edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: handleEdit,
      visible: true,
    },
  ];

  const customCellRenderer = (row, accessor) => {
    if (accessor === "isMedicalClearanceManager" || accessor === "isMedicalClearanceProcessor") {
      return (
        <span className={`font-bold ${row[accessor] ? "text-green-600" : "text-gray-300"}`}>
          {row[accessor] ? "YES" : "NO"}
        </span>
      );
    }
    return null;
  };

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace" />
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"Medical Clearance Access"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Medical Clearance Access</h3>
            </div>

            <div className="p-4 space-y-4">
              <SearchBar handleFilter={handleSearch} />
              
              <CreateTable
                tableName={"MedicalClearanceAccessTable"}
                headers={headers}
                accessors={accessors}
                data={data}
                actions={actions}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={10}
                totalItems={data?.length}
                customCellRenderer={customCellRenderer}
              />
            </div>
          </div>
        </div>
      </div>

      <MedicalClearanceAccessModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        template={selectedTemplate}
        onSave={handleSaveAccess}
        loading={loading}
      />

      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
      <LoadingSpinner loading={loading} />
    </>
  );
};

export default MedicalClearanceAccessPage;